import { useState } from 'react';

const FilterPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showFilterPopup, setShowFilterPopup] = useState<boolean>(false);

    const filterPopupToggleHandler = () => {
      setShowFilterPopup(!showFilterPopup);
    };

    return (
      <Component
        showfilterPopup={showFilterPopup}
        filterPopupToggleHandler={filterPopupToggleHandler}
        {...props}
      />
    );
  };

export default FilterPopupHOC;
